// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-game-play-page .game-img-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  aspect-ratio: 85/48;
  margin: 0 auto;
  position: relative;
}
.slot-game-play-page .game-img-wrap .game-img-box {
  width: 100%;
  height: 75dvh;
  border: 6px solid var(--indigo-1000);
  border-radius: 0.75rem 0.75rem 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.slot-game-play-page .game-img-wrap .game-img-box img {
  width: 100%;
  height: 100%;
  border-radius: 0.375rem 0.375rem 0 0;
  object-fit: cover;
  object-position: center;
}
.slot-game-play-page .game-img-wrap .game-img-box iframe {
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 0.375rem 0.375rem 0 0;
  object-fit: cover;
  object-position: center;
}
.slot-game-play-page .game-img-wrap .btn-box {
  background-color: var(--indigo-1000);
  border-radius: 0 0 0.75rem 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding-bottom: 6px;
}
.slot-game-play-page .game-img-wrap .btn-box .back-btn,
.slot-game-play-page .game-img-wrap .btn-box .fullscreen-btn {
  background-color: transparent;
  box-shadow: none;
  color: var(--white-1000);
  text-transform: capitalize;
}
.slot-game-play-page .game-img-wrap .btn-box .back-btn svg,
.slot-game-play-page .game-img-wrap .btn-box .fullscreen-btn svg {
  fill: var(--white-1000);
}
.slot-game-play-page .game-details-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.slot-game-play-page .game-details-section .game-details-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  margin: 0 auto;
}
.slot-game-play-page .game-details-section .game-details-wrap .about-game-section {
  width: 100%;
  padding: 0;
}
.slot-game-play-page .game-details-section .game-details-wrap .game-details-list-section {
  width: 100%;
  max-width: 42.5rem;
  padding: 0;
  margin: 0;
}
@media screen and (max-width: 991.98px) {
  .slot-game-play-page .game-details-section {
    padding: 2.5rem 0;
  }
  .slot-game-play-page .game-details-section .game-details-wrap {
    gap: 1.25rem;
  }
}
@media screen and (max-width: 767.98px) {
  .slot-game-play-page .game-details-section {
    padding: 2rem 0;
  }
  .slot-game-play-page .game-details-section .game-details-wrap {
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    gap: 2.5rem;
  }
  .slot-game-play-page .game-details-section .game-details-wrap .game-details-list-section {
    max-width: unset;
  }
}
@media screen and (max-width: 474.98px) {
  .slot-game-play-page .game-img-wrap .btn-box .back-btn .text,
  .slot-game-play-page .game-img-wrap .btn-box .fullscreen-btn .text {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/SlotGamePlay/SlotGamePlayPageStyle.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAAJ;AAEI;EACE,WAAA;EACA,aAAA;EACA,oCAAA;EACA,kCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAN;AAEM;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,iBAAA;EACA,uBAAA;AAAR;AAGM;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,oCAAA;EACA,iBAAA;EACA,uBAAA;AADR;AAKI;EACE,oCAAA;EACA,kCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAHN;AAKM;;EAEE,6BAAA;EACA,gBAAA;EACA,wBAAA;EACA,0BAAA;AAHR;AAKQ;;EACE,uBAAA;AAFV;AAQE;EACE,eAAA;EACA,cAAA;AANJ;AAQI;EACE,WAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;AANN;AAQM;EACE,WAAA;EACA,UAAA;AANR;AASM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAPR;AAYE;EACE;IACE,iBAAA;EAVJ;EAYI;IACE,YAAA;EAVN;AACF;AAcE;EACE;IACE,eAAA;EAZJ;EAcI;IACE,2BAAA;IACA,mBAAA;IACA,sBAAA;IACA,WAAA;EAZN;EAcM;IACE,gBAAA;EAZR;AACF;AAiBE;EAKQ;;IACE,aAAA;EAlBV;AACF","sourcesContent":[".slot-game-play-page {\n  .game-img-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    aspect-ratio: 85/48;\n    margin: 0 auto;\n    position: relative;\n\n    .game-img-box {\n      width: 100%;\n      height: 75dvh;\n      border: 6px solid var(--indigo-1000);\n      border-radius: 0.75rem 0.75rem 0 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      img {\n        width: 100%;\n        height: 100%;\n        border-radius: 0.375rem 0.375rem 0 0;\n        object-fit: cover;\n        object-position: center;\n      }\n\n      iframe {\n        width: 100%;\n        height: 100%;\n        border: 0;\n        border-radius: 0.375rem 0.375rem 0 0;\n        object-fit: cover;\n        object-position: center;\n      }\n    }\n\n    .btn-box {\n      background-color: var(--indigo-1000);\n      border-radius: 0 0 0.75rem 0.75rem;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 1rem;\n      padding-bottom: 6px;\n\n      .back-btn,\n      .fullscreen-btn {\n        background-color: transparent;\n        box-shadow: none;\n        color: var(--white-1000);\n        text-transform: capitalize;\n\n        svg {\n          fill: var(--white-1000);\n        }\n      }\n    }\n  }\n\n  .game-details-section {\n    padding: 4rem 0;\n    margin: 0 auto;\n\n    .game-details-wrap {\n      width: 100%;\n      max-width: var(--containerWidth);\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      gap: 2rem;\n      margin: 0 auto;\n\n      .about-game-section {\n        width: 100%;\n        padding: 0;\n      }\n\n      .game-details-list-section {\n        width: 100%;\n        max-width: 42.5rem;\n        padding: 0;\n        margin: 0;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    .game-details-section {\n      padding: 2.5rem 0;\n\n      .game-details-wrap {\n        gap: 1.25rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    .game-details-section {\n      padding: 2rem 0;\n\n      .game-details-wrap {\n        justify-content: flex-start;\n        align-items: center;\n        flex-direction: column;\n        gap: 2.5rem;\n\n        .game-details-list-section {\n          max-width: unset;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 474.98px) {\n    .game-img-wrap {\n      .btn-box {\n        .back-btn,\n        .fullscreen-btn {\n          .text {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
